import AppNavbar from '../common/AppNavbar'
import AppFooter from '../common/AppFooter'
import PrintOnlyHeader from '../common/PrintOnlyHeader'
import ChatwootWidget from '../common/Chatwoot'

export default function DefaultAppTheme({ userType, user_session, children }) {
  return (
    <div className='d-flex' style={{ minHeight: '100vh', flexDirection: 'column' }}>
      <AppNavbar user_session={user_session} userType={userType}/>
      <main className='flex-shrink-0 p-3 mt-5z' style={{ marginTop: (window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost')) ? '5rem': '3em'}}>
        <PrintOnlyHeader />
        <ChatwootWidget />
        {children ? children : null}
      </main>
      <AppFooter />
    </div>
  )
}